// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';

const CreditMemoNumberCriteria = props =>
    <div className='credit-memo-number-criteria'>
        <LabeledCriteria
            className='credit-memo-number-criteria'
            isRequired={false}
            label='CREDIT_MEMO'
            maxLength='17'
            onInputChange={props.handleCreditMemoNumberInputChange}
            placeholder='CREDIT_MEMO'
            type='text'
            value={props.creditMemoValue}
        />
    </div>;

CreditMemoNumberCriteria.displayName = 'CreditMemoNumberCriteria';
CreditMemoNumberCriteria.propTypes = {
    creditMemoValue: PropTypes.string.isRequired,
    handleCreditMemoNumberInputChange: PropTypes.func.isRequired
};

export default CreditMemoNumberCriteria;




// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/credit-memo-number-criteria.js